import React, { Fragment, useEffect } from 'react';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DefaultContain from 'Component/DashboardQeza/Doctor';

const Category = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>
            <Breadcrumbs parent="Dokter" title="Daftar Dokter" />
            <DefaultContain />
        </Fragment>
    );
};
export default Category;